const jobslips = {
  JOBSLIPS: 'JOBSLIPS',
  JOBSLIPSS: 'JOBSLIPSS',
  SINGLE_JOBSLIPS_GET: 'SINGLE_JOBSLIPS_GET'
}
export { jobslips }
